import type { DirectorPendingItem, WorkflowColumn } from '@/types/director'
import { documentWorkOpen } from '@/utils/documentDue'

export function deriveWorkflowColumn(item: DirectorPendingItem): WorkflowColumn {
  if (item.kind === 'notice') {
    return 'ready'
  }
  if (item.kind === 'retro') {
    return 'documents_pending'
  }
  const hasFile = Boolean(item.has_document ?? item.documents_received)
  const due = Boolean(item.document_due)
  if (documentWorkOpen(due, item.documents_requested_at, hasFile)) {
    return 'documents_pending'
  }
  return 'ready'
}
